export class Identifiers {
   public rut?: string;
   public companyRut?: string;
   public userName?: string;
   public email?: string;
   public companySubsidiary?: string;
   constructor() {}
}
